import { render, staticRenderFns } from "./PageModule.vue?vue&type=template&id=d66b07fc&scoped=true&"
import script from "./PageModule.vue?vue&type=script&lang=js&"
export * from "./PageModule.vue?vue&type=script&lang=js&"
import style0 from "./PageModule.vue?vue&type=style&index=0&id=d66b07fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d66b07fc",
  null
  
)

component.options.__file = "PageModule.vue"
export default component.exports